import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { AutomotiveAftermarketEndpoint } from '../constants/automotive-aftermarket-endpoint';
import { MonitoringFilterNameDictionary } from '../../../../models';

@Injectable({
  providedIn: 'root',
})
export class AutomotiveAftermarketFiltersDictionaryService {
  constructor(private http: WrapperHttpService) {}

  getAutomotiveAftermarketFiltersDictionary(): Observable<MonitoringFilterNameDictionary[]> {
    const url = `${API_URL}${AutomotiveAftermarketEndpoint.Base}${AutomotiveAftermarketEndpoint.FiltersDictionary}`;
    return this.http.withLoading().get<MonitoringFilterNameDictionary[]>(url);
  }
}
